import "./CompletingOrderOverlayComponent.scss";
import {IComponentOptions} from "angular";

export const CompletingOrderOverlay = "tfStoreCompletingOrderOverlay";

export function completingOrderOverlay(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/completing-order-overlay/CompletingOrderOverlayComponent.html`,
        controllerAs: "ctrl",
        controller: CompletingOrderOverlayComponentController
    };
}

export class CompletingOrderOverlayComponentController {

}
